<template>
<div>

    <div class="box partner-box" style="display: grid; place-items: center;" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/dell.jpg" style="max-width: 75%;" alt="Dell Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div style="display: grid; place-items: center;">
            <img src="https://assets.webbank.com/partners/dell.jpg" style="max-width: 200px;" alt="Dell Logo">
          </div>
            <br>
            <p>In partnership with Dell Financial Services, WebBank is the issuer and lender of the Dell Preferred Account.</p>
            <br>
            <p>The Dell Preferred Account provides a revolving line of credit for consumers with special financing offers and low monthly payments.
                If you are interested in applying, click <a href="#" title="Apply at Dell" @click="$emit('link-click', 'https://www.dell.com/financing/comm/dpamarcom/CreditApp?cookieUpdated=true')">here</a>.
                If you have any questions about the <a href="#" title="Dell Preferred Account" @click="$emit('link-click', 'https://www.dell.com/en-us/lp/dell-financing-details')">Dell Preferred Account</a>,
                you can learn more here or you can speak to a Dell Financial Services representative by calling 800-283-2210.</p>

            <br>
            <p><a href="#" title="Dell Credit Agreement" @click="$emit('link-click', 'https://www.dell.com/en-us/learn/preferred-account/credit-agreement')">Dell Preferred Account Cardholder Agreement</a></p>
            <br>
            <p><a href="#" title="Dell Financial Services Privacy Policy" @click="$emit('link-click', 'https://www.dell.com/learn/us/en/uscorp1/policies-privacy')">Dell Financial Services Privacy Policy</a></p>
            <br>
            <p><a href="#" title="Dell Financial Services Privacy Notice" @click="$emit('link-click', 'https://i.dell.com/sites/csdocuments/DFS_Docs/en/DFS_Privacy_Policy.pdf?ref=cptl_43cdcca3-bdd8-4a85-9532-e2170c9a7fc2_cta_link_consumerprivacynoticeofdellfinancialservicesllc')">Dell Financial Services Privacy Notice</a></p>
            <br>
            <p><a href="#" title="WebBank Privacy Notice" @click="$emit('link-click', 'https://i.dell.com/sites/csdocuments/DFS_Docs/en/DPA_Privacy_Policy.pdf?ref=cptl_43cdcca3-bdd8-4a85-9532-e2170c9a7fc2_cta_link_consumerprivacynoticeofwebbankfordellfinancialservices')">WebBank Privacy Notice</a></p>
            <br>

            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
